<template>
  <div class="page">
    <div class="item">
      <conditional-search-tiqian @onSearch='onSearch' v-model="check" :new_batch="new_batch" :piciLIst="piciLIst" />
    </div>

    <div style="min-height: 100px;margin-top: 20px;">
      <college-list-tiqian v-loading="loading" v-for="(item, i) in CollegeData" :userInfo="userInfo" :item="item"
        :record="record" :key="i" @refush=updateReport :state="state">
      </college-list-tiqian>
    </div>

    <div class="main">
      <template>
        <div style="text-align: center; margin-bottom: 20px">
          <el-pagination @current-change="handleCurrentChange" :page-size="page.pageSize" layout=" prev, pager, next"
            :total="page.total" :current-page.sync="page.currentPage">
          </el-pagination>
        </div>
      </template>
    </div>

  </div>
</template>

<script>
import ConditionalSearchTiqian from "./components/ConditionalSearchTiqian";
import CollegeListTiqian from "./components/CollegeListTiqian";

export default {
  props: ['userInfo', 'updateStatus'],

  name: '',
  data() {
    return {
      CollegeData: [],
      //筛选条件
      check: {
        pici: '本科提前批行业类',
        name: '',
      },
      piciLIst: [],
      page: {
        pageNum: 1,
        pageSize: 30,
        total: 0,
        currentPage: 1,
      },
      new_batch: 1,
      len: 64,
      record: {
        table: [],
        id_list: [],
      },
      remarks: '',
      state: 1,
    };
  },
  components: {
    ConditionalSearchTiqian,
    CollegeListTiqian
  },
  created() {
    this.$emit('setNav', 0, 1)
    if (this.userInfo.subject_id) {
      this.getList()
      this.getRecode()
      this.getNav()
    }
  },
  methods: {
    //搜索
    onSearch(e) {
      this.check = e
      this.page.currentPage = 1
      this.page.pageNum = 1

      this.getList()
    },

    //条件搜索
    getNav() {
      let wenli = 1
      if (this.userInfo.subject == 4) {
        wenli = 1
      } else {
        wenli = 2
      }
      this.$fecth
        .post("volunteer_tiqian/get_nav", {
          is_wenli: wenli,
          new_batch: this.new_batch,
        })
        .then((res) => {
          this.piciLIst = res.data
        });

    },

    getList() {
      let wenli = 1
      if (this.userInfo.subject == 4) {
        wenli = 1
      } else {
        wenli = 2
      }
      this.$fecth
        .post("volunteer_tiqian/get_t_plan", {
          pageNum: this.page.pageNum,
          pageSize: this.page.pageSize,
          name: this.check.name,
          subject_id: this.userInfo.subject_id,
          is_wenli: wenli,
          new_batch: this.new_batch,
          pici: this.check.pici,
        })
        .then((res) => {
          res = res.data;
          this.loading = false;
          this.CollegeData = res.lists;
          this.page.total = res.count;
        });
    },

    //获取志愿表
    getRecode() {
      let data = {
        user_id: this.userInfo.id,
        subject: this.userInfo.subject,
        new_batch: this.new_batch,
      }
      this.$fecth.post("volunteer_tiqian/get_report_tiqian", data).then((res) => {
        if (res.data.record) {
          this.record = JSON.parse(res.data.record)
          this.remarks = res.data.remarks
        } else {
          for (let i = 0; i < this.len; i++) {
            this.record.table.push({
              name: "暂无",
            });
            this.record.id_list.push('')
          }
        }
        this.record.table = this.record.table.slice(0, 64)
        this.record.id_list = this.record.id_list.slice(0, 64)
      })
    },

    //更新志愿表
    updateReport(record) {
      this.$fecth
        .post("volunteer_tiqian/updateReport", {
          user_id: this.userInfo.id,
          subject: this.userInfo.subject,
          new_batch: this.new_batch,
          record: JSON.stringify(record)
        })
      this.state++
    },
    //翻页
    handleCurrentChange(val) {
      this.page.pageNum = val;
      this.getList();
    },
  },
};
</script>

<style scoped lang='less'>
.page {
  width: 1400px;
  background: white;
  padding: 20px 60px;
}
</style>
